import React from 'react';
import { PaymentForm } from '../components/PaymentForm';
import { SettingsIcon } from 'lucide-react';
export function PaymentRequests() {
  const navigateToSettings = () => {
    window.location.href = '/settings';
  };
  return <div data-id="element-1965">
      {/* Header with settings button */}
      <div className="mb-6 flex justify-between items-center" data-id="element-1966">
        <h2 className="text-lg font-medium text-gray-800" data-id="element-1967">
          Create Payment Request
        </h2>
        <button className="flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 transition-colors" onClick={navigateToSettings} data-id="element-1968">
          <SettingsIcon size={16} className="mr-2" data-id="element-1969" />
          Payment Settings
        </button>
      </div>
      <PaymentForm data-id="element-1970" />
    </div>;
}